import React, { Component } from 'react';
import MyButton from '../../components/MyButton/MyButton';
import Strings from 'localization/Strings';
import './Age.css';

class Age extends Component {
    constructor(props){
        super(props);
        this.onSubmit = props.onSubmit;
    }

    render () {
        return (
            <div className='component-card-content '>
                <div>
                    <h4 className="heading1 text-left">{Strings.strings.Age.Title}</h4>
                    <h2 className="display1 text-left pt20">{Strings.strings.Age.Description}</h2>
                    <div className="text-center pt50">
                        <MyButton type="white" className="my-button answer-button answer-button-5 age-btn" onClick={() => this.onSubmit({user_selection_age:"<50"})} text={Strings.strings.Age.ButtonSmallerThan50}/>
                        <MyButton type="white" className="my-button answer-button answer-button-5 age-btn" onClick={() => this.onSubmit({ user_selection_age: "50-60" })} text={Strings.strings.Age.Button50To60} />
                        <MyButton type="white" className="my-button answer-button answer-button-5 age-btn" onClick={() => this.onSubmit({ user_selection_age: "60-70" })} text={Strings.strings.Age.Button60To70} />
                        <MyButton type="white" className="my-button answer-button answer-button-5 age-btn" onClick={() => this.onSubmit({ user_selection_age: "70-80" })} text={Strings.strings.Age.Button70To80} />
                        <MyButton type="white" className="my-button answer-button answer-button-5 age-btn" onClick={() => this.onSubmit({ user_selection_age: ">80" })} text={Strings.strings.Age.Button80Plus} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Age;